import { useMemo } from 'react';

import { IPositionWithCandidates } from '@types';
import {
  collectRegions,
  collectSeniorities,
  collectStatusFacets,
} from '@utils';

export const useFilterOptions = (data: IPositionWithCandidates[]) =>
  useMemo(
    () => ({
      regions: collectRegions(data),
      seniorities: collectSeniorities(data),
      statusFacets: collectStatusFacets(data),
    }),
    [data],
  );

export type FilterOptions = ReturnType<typeof useFilterOptions>;
